'use client';

import { c as _c } from "react/compiler-runtime";
import { LinkPlaceholder, NavTabs as NavTabsCore } from '@sola/ark-core/molecules/nav-tabs/nav-tabs.tsx';
import { NavigationProps } from '@sola/schema/lib/schema.ts';

/**
 * Subpage Navigation.
 *
 * Not using ark/core/tabgroup since functionality needs are much different,
 * we want to avoid radix deps, and keeping it seperate could make the design more flexible.
 */
export const NavTabs: React.FC<NavigationProps> = t0 => {
  const $ = _c(4);
  const {
    items
  } = t0;
  if (!items || items.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== items) {
    t1 = items.map(_temp);
    $[0] = items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <NavTabsCore links={t1} />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
function _temp(item, index) {
  return {
    id: index.toString(),
    title: item.title,
    path: item.link
  } as LinkPlaceholder;
}